export const lg_create_meetroom = {
  create_meetroom_th: {
    title: "ยินดีต้อนรับเข้าสู่ระบบ Dmeets",
    create_room_now: "สร้างห้องประชุมใหม่",
    create_room_schedule: "สร้างห้องล่วงหน้า",
    meet_topic: "ชื่อห้องประชุม",
    enter_meet_topic: "ใส่ชื่อห้องประชุม",
    meet_date_start: "วันที่เริ่ม",
    meet_time_start: "เวลาที่เริ่ม",
    meet_password: "รหัสผ่าน (ใส่หรือไม่ใส่ก็ได้)",
    meet_create: "สร้างห้องประชุม",
    meet_option: "ตัวเลือกการประชุม",
    meet_option_record_on_start: "เริ่มบันทึกเมื่อเริ่มประชุม",
    meet_option_sub_record_on_start: "ระบบจะเริ่มบันทึกการประชุมโดยอัตโนมัติทันทีที่การประชุมเริ่มต้น",
    meet_option_lobby: "ห้องรองรับ",
    meet_sub__option_lobby: " เฉพาะผู้ใช้ที่ได้รับอนุญาตจากโฮสต์เท่านั้นจึงจะสามารถเข้าร่วมการประชุมได้",
    meet_option_verify_identify: "ยืนยันตัวตน",
    meet_option_share_screen: "อนุญาตให้ผู้เข้าร่วมแชร์หน้าจอ",
    titlemeeterror:"ผิดพลาด",
    contentmeeterror:"สิ้นสุดการประชุม",
    contentmeetiderror:"Meeting ID ไม่ถูกต้อง",
    enter_meeting_details:"กรุณากรอกรายละเอียดการประชุม",
    passcode:"รหัสผ่าน",
    passcode_subtitle:"เฉพาะผู้ใช้ที่มีรหัสผ่านเท่านั้นจึงจะสามารถเข้าร่วมการประชุมได้",
    requireauthenticationtojoin:"ต้องมีการยืนยันตัวตนเพื่อเข้าร่วม",
    OTPverification:"ยืนยันด้วย OTP",
    LogintoDmeets:"เข้าสู่ระบบ Dmeets",
    checkrequireauthenticationtojoin:"ตรวจสอบ ต้องมีการยืนยันตัวตนเพื่อเข้าร่วม",
    checkpasscode:"ตรวจสอบ รหัสผ่าน",
    checkmeet_topic: "ตรวจสอบ หัวข้อการประชุม",
    checkmeet_dateandtime: "ตรวจสอบ วันและเวลาการประชุม",
    create_meet_date: "วัน/เวลา การประชุม (UTC/GMT+7)",
    select_meeting_date_and_time:"เลือกวันและเวลาการประชุม",
    btn_cancel:"ยกเลิก",
  },
  create_meetroom_en: {
    title: "Welcome to Dmeets",
    create_room_now: "New meeting",
    create_room_schedule: "Create a schedule room",
    meet_topic: "Meeting Name",
    enter_meet_topic: "Enter meeting name",
    meet_date_start: "Start Date",
    meet_time_start: "Start Time",
    meet_password: "Password (optional)",
    meet_create: "Create meeting",
    meet_option: "Meeting Options",
    meet_option_record_on_start: "Record on start",
    meet_option_sub_record_on_start: "Automatically begin recording as soon as the meeting starts.",
    meet_option_lobby: "Waiting Room",
    meet_sub__option_lobby: "Only users admitted by the host can join the meeting",
    meet_option_verify_identify: "Verify user's identity",
    meet_option_share_screen: "Allow share screen",
    titlemeeterror:"Error",
    contentmeeterror:"The meeting was finished",
    contentmeetiderror:"Meeting ID Incorrect",
    enter_meeting_details:"Please enter meeting details",
    passcode:"Passcode",
    passcode_subtitle:"Only users who have to passcode can join the meeting.",
    requireauthenticationtojoin:"Require authentication to join",
    OTPverification:"OTP verification",
    LogintoDmeets:"Login to Dmeets",
    checkrequireauthenticationtojoin:"Check Require authentication to join",
    checkpasscode:"Check Passcode",
    checkmeet_topic: "Check Meeting Topic",
    checkmeet_dateandtime: "Check meeting date and time",
    create_meet_date: "Meeting Date/Time: (UTC/GMT+7)",
    select_meeting_date_and_time:"Select meeting date and time",
    btn_cancel:"Cancel",
  },
};
